module.exports = __webpack_public_path__ + "static/event-c3453944ea45835b0007973a5edb1f33.png";